<template>
  <div>
    <div class="form_header">
      <div>
        <h6>{{ $l('form_title_image') || '产品相关图片' }}</h6>
        <p>
          {{ $l('form_paragraph_image') || '业务人员上传的关于该产品的图片' }}
        </p>
      </div>
      <div class="ml-5" v-if="!disabled">
        <b-button variant="outline-primary" size="sm" @click="uploadImg()">
          <b-icon-plus></b-icon-plus>
          {{ $l('btn_uploadImg') || '图片上传' }}
        </b-button>
      </div>
    </div>
    <div class="form_content">
      <div class="image-item" v-for="(item, index) in list" :key="index">
        <div class="image-card">
          <el-image :src="item.thumbImageUrl" fit="cover" />
          <div class="image-opts">
            <i
              class="el-icon-delete tool-btn"
              @click="del(item)"
              v-if="!disabled"
            />
            <i class="el-icon-zoom-in tool-btn" @click="preview(index)" />
          </div>
        </div>
        <div class="image-desc">
          <p>{{ `Sent at ${item.modifyDate}` }}</p>
          <div class="image-upload">
            <el-avatar :size="24" :src="item.modifyByMemImgUrl">
              <span>U</span>
            </el-avatar>
            <span>{{ item.modifyByName }} </span>
          </div>
        </div>
      </div>

      <div v-if="isEmpty" class="empty-content">
        <img src="/image/static/img/nodata.png" />
        <p>{{ $l('INDEX.tips_no_data') || '暂无数据！' }}</p>
      </div>
    </div>

    <div v-show="false" class="imagesViewer" v-viewer="{ movable: true }">
      <img
        v-for="(item, index) in list"
        :src="item.displayImageUrl || '/image/static/img/nopic.jpg'"
        :key="index"
      />
    </div>
  </div>
</template>

<script>
import { VXETable } from 'vxe-table'
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [EditLoading],
  props: {
    proofingCode: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
  },
  data() {
    return {
      list: [],
      loading: false,
    }
  },
  computed: {
    isEmpty() {
      return !this.list?.length
    },
  },
  mounted() {
    this.getData()
  },
  methods: {
    async getData() {
      if (!this.proofingCode) return
      this.loading = true
      const res = await this.$api
        .customerProofingImageListApi({ proofingCode: this.proofingCode })
        .catch(() => null)
      this.loading = false
      if (!res) return
      this.list = res.body.data
    },
    async uploadImg() {
      const { files } = await VXETable.readFile({
        types: ['jpeg', 'JPEG', 'jpg', 'JPG', 'png', 'PNG', 'gif', 'GIF'],
        multiple: true,
      }).catch(() => ({}))
      if (!files?.length) return

      if (files.length > 10) {
        const msg = `${this.$l('tips_warning_uploadLimit_1') ||
          '当前限制一次选择10张图片，本次选择了'} ${files.length} ${this.$l(
          'tips_warning_uploadLimit_2'
        ) || '张图片'}`
        this.$message.warning(msg)
        return
      }

      const uploadTask = Array.from(files).map((item) =>
        this.$api
          .SYS_UPLOAD(item)
          .then((res) => ({
            originImageCode: res.body.fileId,
            originImageUrl: res.body.url,
          }))
          .catch(() => null)
      )

      if (this.loadingOpen()) return
      const listImage = await Promise.all(uploadTask)
      if (listImage.includes(null)) {
        this.$message.warning(
          this.$l('tips_warning_uploadImage') || '图片上传失败，请联系管理员'
        )
        this.loadingClose()
        return
      }

      const params = { proofingCode: this.proofingCode, listImage }
      const res = await this.$api
        .customerProofingImageUploadApi(params)
        .catch(() => null)
      this.loadingClose()

      if (!res) return
      const { status } = res
      if (status !== 200) {
        this.$message.error(
          this.$l('INDEX.uploader_label_status_error') || '上传失败'
        )
        return
      }

      this.$message({
        showClose: true,
        message: this.$l('INDEX.uploader_label_status_success'),
        type: 'success',
      })
      this.getData()
    },
    async del({ proofingImgCode }) {
      const confirm = await this.$confirm(
        this.$l('INDEX.tips_delete') || '是否要删除该记录？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText: this.$l('INDEX.btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      )
        .then(() => true)
        .catch(() => false)
      if (!confirm) return

      if (this.loadingOpen()) return
      const res = await this.$api
        .customerProofingImageDelApi({ proofingImgCode })
        .catch(() => null)
      this.loadingClose()

      if (!res) return
      const { status } = res
      if (status !== 200) {
        this.$message.error(this.$l('INDEX.tips_delete_no') || '删除失败！')
        return
      }

      this.$message({
        showClose: true,
        message: this.$l('INDEX.tips_delete_ok') || '删除成功！',
        type: 'success',
      })
      this.getData()
    },
    async preview(index) {
      if (!this.list?.length) return
      this.viewer = this.$el.querySelector('.imagesViewer').$viewer
      this.viewer.view(index)
      this.viewer.show()
    },
  },
}
</script>

<style lang="scss" scoped>
.form_header {
  display: flex;
  align-items: flex-end;
  margin-bottom: 10px;
  h6 {
    color: #101010;
  }
  p {
    font-size: 14px;
    color: #8f97ad;
    margin-bottom: 0;
  }
}
.form_content {
  border: 1px dashed #bbbbbb;
  border-radius: 5px;
  padding: 10px 5px 0;
  display: flex;
  flex-wrap: wrap;
}

.image-item {
  padding: 0 5px;
  margin-bottom: 10px;
  .image-card {
    width: 180px;
    height: 120px;
    position: relative;
    .el-image {
      width: 100%;
      height: 100%;
      border-radius: 5px;
    }
    .image-opts {
      border-radius: 5px;
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      opacity: 0;
      transition: opacity 0.3s;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #fff;
      i {
        font-size: 20px !important;
      }
    }
  }
  .image-card:hover {
    .image-opts {
      opacity: 1;
      background-color: rgba(0, 0, 0, 0.5);
    }
  }
  .image-desc {
    font-size: 12px;
    color: #8f97ad;
    p {
      margin-top: 5px;
      margin-bottom: 5px;
    }
    .image-upload {
      display: flex;
      align-items: center;
      .el-avatar {
        margin-right: 5px;
        img {
          width: 100%;
        }
      }
    }
  }
}

.empty-content {
  text-align: center;
  flex: 1;
  padding: 10px 20px 20px;
  p {
    font-size: 13px;
    color: #606266;
    margin-top: 10px;
    margin-bottom: 0;
  }
}
</style>
